export const SERVICE_DESK_PRODUCT = 'servicedesk';
